function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.5 46.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25,46.49A23.25,23.25,0,1,0,0,23.25,23.24,23.24,0,0,0,23.25,46.49",
    style: {
      fill: "#fdb913"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47,24.67A14.7,14.7,0,0,0,18,38.44c8.09,3.62,21.21-8.28,20.66-15.15",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.19,16.88c.07-.08-.05-1.19.76-.06-1.73-.54-.17-.82.48-1.74",
    style: {
      fill: "#ed1c29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.19,16.88c.07-.08-.05-1.19.76-.06-1.73-.54-.17-.82.48-1.74",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.89,16.88c.07-.08-.05-1.19.76-.06-1.73-.54-.17-.82.48-1.74",
    style: {
      fill: "#ed1c29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.89,16.88c.07-.08-.05-1.19.76-.06-1.73-.54-.17-.82.48-1.74",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2,22.56C38,24,40.58,25,42.53,24.28",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.63,2.7C7.65,1.08-5.8,23.17,9.24,38.53c19.51,19.92,50-11.2,26.34-32.79",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceYellow);
export default __webpack_public_path__ + "static/media/faceYellow.44f3a219b462fe66cf7754c12617d904.svg";
export { ForwardRef as ReactComponent };